import * as React from "react"
import { useCallback, useMemo } from "react"
import { Appearance, Dimensions, Platform, StyleProp, TouchableOpacity, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { PickerActionsheet } from "../picker-actionsheet/picker-actionsheet"
import { JalaIcon } from "../jala-icon/jala-icon"
import { Icon, useDisclose, View } from "native-base"
import { useStores } from "../../models"
import { ListRenderItem } from "../flat-list/flat-list"
import { useSafeAreaInsets } from "react-native-safe-area-context"

const CONTAINER: ViewStyle = {
  alignItems: 'center',
  flexDirection: 'row'
}

const ACTION_SHEET_ITEM: ViewStyle = {
  minHeight: 44,
  flexDirection: "row",
  alignItems: "center",
  paddingHorizontal: 16,
}

const data = [
  { label: "Bahasa Indonesia", key: "id" },
  { label: "English", key: "en" },
  { label: "Tiếng Việt", key: "vi" },
  { label: "Español", key: "es" },
]

export interface PickerLanguageProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>,

  colorScheme?: "light" | "dark"
}

/**
 * Describe your component here
 */
export const PickerLanguage = observer(function PickerLanguage(props: PickerLanguageProps) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const { appStore: { locale, setLocale } } = useStores()
  const insets = useSafeAreaInsets()

  const { isOpen, onOpen, onClose } = useDisclose()

  const onPressItem: (item) => any = useCallback((item) => () => {
    const { LoginStackSplash, resetRoot } = require('../../navigators')
    onClose();
    setLocale(item.key)
    resetRoot(LoginStackSplash)
  }, [onClose, setLocale])

  const renderItem: ListRenderItem<any> = useCallback(({ item }) => {
    return (
      <View style={ACTION_SHEET_ITEM}>
        <Text text={item.label} preset={item.key === locale ? "title4" : "body2"} colorScheme={colorScheme} isTruncated />
      </View>
    )
  }, [colorScheme, locale])

  const flatListProps = useMemo(() => ({
    keyExtractor: (item) => `${item.key}`
  }), [])

  const minHeightMax = Dimensions.get("window").height * (Platform.OS === 'web' ? 0.5 : 0.8);
  const minHeightMin = Dimensions.get("window").height * 0.3;
  const estimatedHeight = (44 * data.length)
    + 24 + 32
    // + 40 + 7
    // + 60
    + insets.bottom;
  let minHeight = minHeightMax;
  if (estimatedHeight < minHeightMin)
    minHeight = minHeightMin;
  else if (estimatedHeight < minHeightMax)
    minHeight = estimatedHeight;

  return (
    <>
      <View>
        <TouchableOpacity testID="jala:id/picker-language" style={CONTAINER} onPress={onOpen}>
          <Text preset="title4" colorScheme={colorScheme} color={colorScheme === "light" ? color.primary : undefined} text={(locale || '').toUpperCase()} />
          <Icon as={<JalaIcon name="expand_more" />} color={colorScheme === "light" ? color.primary : undefined} size="20px" />
        </TouchableOpacity>
      </View>
      <PickerActionsheet
        withoutSearch={true}
        colorScheme={colorScheme}
        isOpen={isOpen}
        onClose={onClose}
        data={data}
        titleTx="language"
        onPressItem={onPressItem}
        renderItem={renderItem}
        flatListProps={{
          estimatedItemSize: 44,
          ...flatListProps
        }}
        actionsheetStyle={{
          minHeight,
          ...(Platform.OS === 'web' ? { maxHeight: Dimensions.get("window").height * 0.5 } : {}),
        }}
      />
    </>
  )
})
